import React from 'react';
export const InputContext = React.createContext(null);
//# sourceMappingURL=InputContext.js.map